import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISidenavTransporterConfiguration } from '../models/sidenav-transporter.configuration';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';

@Injectable({ providedIn: 'root' })
export class SidenavTransporterConfigurationService implements ITransportConfigurationService<ISidenavTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<ISidenavTransporterConfiguration>> {
    return this.apiProvider.publicGet<ISidenavTransporterConfiguration>(this.publicResourceUrl('sidenav', transporterId), { observe: 'response' });
  }

  updateConfiguration(configuration: ISidenavTransporterConfiguration, transporterId?: number): Observable<HttpResponse<ISidenavTransporterConfiguration>> {
    return this.apiProvider.configurationPut<ISidenavTransporterConfiguration>(this.moderatorResourceUrl('sidenav', transporterId), configuration);
  }
}
